function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVikingTyre = function SvgVikingTyre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 382.36 118.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.24 106.09 1.33 118.29 57.47 118.29 69.38 106.09 13.24 106.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.21 106.09 314.3 118.29 370.44 118.29 382.35 106.09 326.21 106.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,0L59.12,87.83c-2.69,3.62-6.51,7-12.45,7s-9.58-3.07-12.27-7L0,35.42l24.74,14.57,23.38,15.3L123.65,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.82,
    y: 35.29,
    width: 18.07,
    height: 58.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.61,93.7h-27.38l-17.63-15.37c-6-5.24-8.82-7.77-10.83-9.78.09,2.71.26,5.59.26,8.38v16.76h-18.11v-58.4h18.16v13.53c0,3.58-.17,7.16-.35,10.22,2.27-2.1,5.41-5.06,10.74-9.52l16.85-14.23h26.19l-22.35,16.76c-7.77,5.85-11.35,8.47-15.1,10.74,3.32,2.27,7.86,5.5,15.36,11.61l24.19,19.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.05,
    y: 35.29,
    width: 18.07,
    height: 58.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.84,91.51l-35.79-32.13v34.31h-16.42v-48.45c0-7.77,4.71-10.91,9.87-10.91,2.18,0,4.36.52,7.25,3.14l35.8,32.13v-34.31h16.5v48.37c0,7.77-4.71,11-10,11-2.27,0-4.45-.52-7.25-3.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.23,57.21h37.37v36.49h-40.06c-20.26,0-35.19-12.83-35.19-29.77s14.93-28.64,35.19-28.64h41.82l-11.7,15.22h-30.12c-9.78,0-17.2,5.94-17.2,14.23s7.16,14,17.2,14h22.09v-8.53h-30.21l10.81-13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,113.58c-1-1.79-1.47-2.65-1.87-3.49-.36.83-.83,1.69-1.84,3.47l-1.86,3.3c-.37.77-1.15,1.25-2,1.23-.97.02-1.81-.65-2-1.6l-3-10.21h3.59l1.09,4c.37,1.3.61,2.26.78,3.19.38-.82.83-1.7,1.63-3.21l1.56-2.92c.31-.83,1.12-1.36,2-1.3.91-.09,1.76.44,2.08,1.3l1.55,2.93c.87,1.6,1.27,2.41,1.63,3.19.19-.92.45-1.91.8-3.19l1.09-4h3.51l-3,10.21c-.19.95-1.03,1.62-2,1.6-.85.02-1.63-.46-2-1.23l-1.74-3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76,117.9h-3.53v-4.48h-7v4.48h-3.61v-11.61h3.61v4.11h7v-4.11h3.58l-.05,11.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.58,112.09c0,4.15-2.85,6-8.49,6s-8.49-1.86-8.49-6,2.83-6,8.49-6,8.49,1.85,8.49,6ZM124,112.09c0-2.5-1.3-3-4.91-3s-4.91.47-4.91,3,1.3,3,4.91,3,4.91-.51,4.91-3h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.98,114.92l-2.33,3h-10.25v-11.63h3.59v8.63h8.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,114.92l-2.31,3h-11.18v-11.63h13.45l-2.33,3h-7.52v1.39h9.2l-2.07,2.64h-7.14v1.58l9.9.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66,110.92c2.83,0,4.36,1.06,4.36,3.18,0,2.38-1.44,3.8-5,3.8h-10.79l2.31-3h8.78c.85,0,1.23-.24,1.23-.85s-.38-.83-1.23-.83h-6.32c-3,0-4.36-1.34-4.36-3.33,0-2.19,1.46-3.61,5-3.61h10.08l-2.31,3h-8.05c-.83,0-1.23.21-1.23.8s.4.82,1.23.82l6.3.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,117.9l2.17-3h4.99c-.31-.42-.8-1.13-1.18-1.68l-2.08-3.07-5.45,7.71h-4.25l7.45-10.5c.5-.8,1.38-1.29,2.33-1.3.94,0,1.81.5,2.29,1.3l7.26,10.5-13.53.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,114.92l-2.33,3h-10.25v-11.63h3.59v8.63h8.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.58,114.92l-2.31,3h-11.17v-11.63h13.45l-2.33,3h-7.52v1.39h9.2l-2.07,2.64h-7.13v1.58l9.88.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,106.29l-2.33,3h-4.15v8.59h-3.59v-8.57h-5.45l2.33-3,13.19-.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.61,106.29l-6.89,7.78v3.84h-3.61v-3.85l-7.08-7.76h4.62l2.78,3.23c.36.42,1.34,1.47,1.58,1.82.22-.33.62-.83,1.46-1.84l2.64-3.21h4.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,117.9h-4.81l-2.59-3.07h-5.52v3.07h-3.59v-5.94h10.1c1.11,0,2-.5,2-1.3s-.75-1.35-2-1.35h-10.1l2.35-3h7.46c2.64,0,6,.83,6,4.15.05,1.8-1.23,3.36-3,3.68.58.47,1.13.98,1.63,1.53l2.07,2.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,114.92l-2.31,3h-11.17v-11.63h13.45l-2.33,3h-7.48v1.39h9.2l-2.06,2.64h-7.14v1.58l9.84.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.07,110.92c2.83,0,4.36,1.06,4.36,3.18,0,2.38-1.44,3.8-5,3.8h-10.8l2.31-3h8.78c.85,0,1.23-.24,1.23-.85s-.38-.83-1.23-.83h-6.32c-3,0-4.36-1.34-4.36-3.33,0-2.19,1.46-3.61,5-3.61h10.09l-2.31,3h-8.05c-.83,0-1.23.21-1.23.8s.4.82,1.23.82l6.3.02Z",
    style: {
      fill: "#fff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVikingTyre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "vikingTyre.svg";
export { ForwardRef as ReactComponent };